import React from 'react';
import { Container, Row, Col, ProgressBar } from 'react-bootstrap';
import './AboutSection.css';

const skills = [
    { name: 'Odoo ERP Development', level: 95 },
    { name: 'Magento & E-commerce', level: 90 },
    { name: 'Server Linux & Cloud', level: 88 },
    { name: 'Mobile Apps (Flutter)', level: 82 },
    { name: 'VoIP Asterisk', level: 85 },
    { name: 'Database & Performance', level: 87 }
];

function AboutSection() {
    return (
        <section id="about" className="about-section section-padding">
            <Container>
                <Row className="align-items-center">
                    <Col lg={6} className="mb-5 mb-lg-0">
                        <div className="about-image-container fade-in">
                            <div className="about-image">
                                <img
                                    src="/images/developer.jpg"
                                    alt="Sviluppo Software e Sistemi IT - BearSoftware"
                                    className="img-fluid rounded-3"
                                />
                                <div className="about-decoration"></div>
                            </div>
                        </div>
                    </Col>

                    <Col lg={6}>
                        <div className="about-content fade-in-up">
                            <h2 className="section-title">
                                Chi <span className="gradient-text">Sono</span>
                            </h2>

                            <p className="about-text">
                                Sono un programmatore e sistemista specializzato in Odoo ERP,
                                e-commerce Magento e infrastrutture server. Con oltre 25 anni di esperienza,
                                trasformo le esigenze aziendali in soluzioni digitali complete e performanti.
                            </p>

                            <p className="about-text">
                                Sono specialista nello sviluppo di moduli Odoo personalizzati, e-commerce Magento/WooCommerce,
                                centralini VoIP Asterisk e gestione di server Linux. Ogni progetto è realizzato 
                                con competenza tecnica e attenzione ai dettagli per garantire il successo del tuo business.
                            </p>

                            <div className="stats-container">
                                <div className="stat-item">
                                    <h3 className="stat-number gradient-text">50+</h3>
                                    <p className="stat-label">Progetti Completati</p>
                                </div>
                                <div className="stat-item">
                                    <h3 className="stat-number gradient-text">25+</h3>
                                    <p className="stat-label">Anni di Esperienza</p>
                                </div>
                                <div className="stat-item">
                                    <h3 className="stat-number gradient-text">40+</h3>
                                    <p className="stat-label">Clienti Soddisfatti</p>
                                </div>
                            </div>

                            <h4 className="skills-title">Le Mie Competenze</h4>
                            <div className="skills-container">
                                {skills.map((skill, index) => (
                                    <div key={index} className="skill-item">
                                        <div className="skill-header">
                                            <span className="skill-name">{skill.name}</span>
                                            <span className="skill-percentage">{skill.level}%</span>
                                        </div>
                                        <ProgressBar
                                            now={skill.level}
                                            className="custom-progress"
                                            style={{ animationDelay: `${index * 0.2}s` }}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default AboutSection;